import SimpleParagraph from '~/components/atoms/Editorial/SimpleParagraph.vue';
import GlobalSelection from '~/components/molecules/Editorial/Global/GlobalSelection.vue';
import { EMPTY_PIXEL } from '~/const/images';
import { formatPrismicImage } from '~/helpers/image-helper';
var GlobalRichText = () => import('~/components/atoms/Editorial/Global/GlobalRichText.vue');
export default {
  name: 'GlobalFooter',
  components: {
    GlobalSelection,
    GlobalRichText,
    SimpleParagraph
  },
  props: {
    payload: {
      type: Object,
      required: true
    }
  },
  computed: {
    currentPayload() {
      var {
        primary
      } = this.payload;
      return {
        background: (primary === null || primary === void 0 ? void 0 : primary.background_color) || '',
        textColor: (primary === null || primary === void 0 ? void 0 : primary.text_color) || '',
        title: (primary === null || primary === void 0 ? void 0 : primary.rich_text) || [],
        subtitle: (primary === null || primary === void 0 ? void 0 : primary.subtitle) || [],
        paragraph: (primary === null || primary === void 0 ? void 0 : primary.paragraph) || [],
        is_last_element: primary === null || primary === void 0 ? void 0 : primary.is_last_element,
        selections: this.payload.items.map(i => {
          var _i$url, _i$background_image, _i$background_image$s, _i$background_image2, _i$background_image2$;
          return {
            url: (i === null || i === void 0 ? void 0 : (_i$url = i.url) === null || _i$url === void 0 ? void 0 : _i$url.url) || '',
            textColor: (i === null || i === void 0 ? void 0 : i.text_color) || '',
            title: (i === null || i === void 0 ? void 0 : i.title[0]) || {},
            description: (i === null || i === void 0 ? void 0 : i.description) || '',
            cta: (i === null || i === void 0 ? void 0 : i.cta) || '',
            image: {
              small: formatPrismicImage(i === null || i === void 0 ? void 0 : (_i$background_image = i.background_image) === null || _i$background_image === void 0 ? void 0 : (_i$background_image$s = _i$background_image.small) === null || _i$background_image$s === void 0 ? void 0 : _i$background_image$s.url, ['w_90,dpr_2']) || EMPTY_PIXEL,
              large: formatPrismicImage(i === null || i === void 0 ? void 0 : (_i$background_image2 = i.background_image) === null || _i$background_image2 === void 0 ? void 0 : (_i$background_image2$ = _i$background_image2.large) === null || _i$background_image2$ === void 0 ? void 0 : _i$background_image2$.url, ['w_375,dpr_2']) || EMPTY_PIXEL
            },
            tracking: {
              data: {
                event_category: (i === null || i === void 0 ? void 0 : i.event_category) || '',
                event_action: (i === null || i === void 0 ? void 0 : i.event_action) || '',
                event_label: (i === null || i === void 0 ? void 0 : i.event_label) || ''
              }
            }
          };
        })
      };
    },
    theParagraph() {
      return this.currentPayload.paragraph && this.currentPayload.paragraph[0] && this.currentPayload.paragraph[0].text;
    },
    countSelections() {
      return this.currentPayload.selections.length;
    },
    isLastElement() {
      return this.currentPayload.is_last_element ? 'pb-0' : null;
    },
    dynamicColumns() {
      switch (this.countSelections) {
        case 1:
          return 'col-md-5';
        case 2:
          return 'col-md-5';
        case 3:
          return 'col-md-4';
        default:
          return 'col-md-3';
      }
    },
    bgColor() {
      return this.currentPayload.background ? this.currentPayload.background : '#F3F3F3';
    }
  }
};